import { Button, styled } from '@auth0/quantum-product';
import React from 'react';
import { login } from '../../../action/navigateAuthentication';
import { useFluxible } from '../../hooks/useFluxible';
import { useTranslation } from '../../hooks/useTranslation';
var StyledLogin = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        alignItems: 'center',
        '& p': {
            marginBottom: 0,
            marginLeft: theme.spacing(1),
        },
    });
});
var Login = function (_a) {
    var quickstartType = _a.quickstartType;
    var t = useTranslation('core').t;
    var fluxibleContext = useFluxible();
    var handleLogin = function () {
        var returnTo = window.location.pathname + window.location.search + window.location.hash;
        fluxibleContext.executeAction(login(returnTo));
    };
    return (React.createElement(StyledLogin, null,
        React.createElement(Button, { size: "medium", variant: "outlined", color: "default", onClick: function () { return handleLogin(); } }, t('appExplorer.header.logInButton', 'Log In')),
        React.createElement("p", null,
            t('appExplorer.header.configureText', 'to configure with your own'),
            ' ',
            quickstartType === 'backend'
                ? t('appExplorer.header.apiText', 'API')
                : t('appExplorer.header.applicationText', 'application.'),
            ".")));
};
export default Login;
